import type { ApiMatrixSubQuestion, ApiQuestion } from '../../../../internalTypes';

export function resolveSubQuestionText(
  sub: ApiMatrixSubQuestion | ApiQuestion,
  language?: string,
  isBipolar?: boolean
): string {
  const subQ = sub as ApiQuestion;
  if (isBipolar && subQ.answerDetails && subQ.answerDetails.length >= 2) {
    const leftText =
      (language && subQ.answerDetails[0].translations?.[language]?.answerText) ||
      subQ.answerDetails[0].answerText ||
      '';
    if (leftText) return leftText;
  }

  const rawText =
    (language && sub.translations?.[language]?.questionText) ||
    sub.questionText ||
    (sub as ApiMatrixSubQuestion).answerText ||
    '';

  if (isBipolar && rawText.includes(':')) {
    return rawText.split(':')[0].trim();
  }
  return rawText;
}
